<template>
  <div id="create">
    <v-container fluid fill-height justify-center id="anpr-listing-view" class="hero">
      

      
    </v-container>
  </div>
</template>
<style scoped>
.hero {
 background: url("../assets/comingsoon.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
    height: 96vh;
}
</style>
<script>
export default {
  name: "CommingSoonView",

  data: () => ({
  }),
  created() {
  },
  mounted() {},
  updated() {
  },
  computed: {
  },
  watch: {
  },
  methods: {

  },
  beforeDestroy() {
  },
};
</script>
